import { smoothScroll } from '..'
import { easeInOutQuad } from '../foundation/easing'
export class KvAnimation {
  constructor() {
    // Maskがかかっているwrapper
    this.body = document.getElementById('js-ship-body')

    // 船
    this.ship = document.getElementById('js-ship-small')

    // KV
    this.kv = document.getElementById('js-kv-mask')

    this.kvShip = document.getElementById('js-fixed_ship')

    this.kvTitle = document.getElementById('js-fixed_title')

    this.cloud = document.querySelectorAll('.js-parallax_cloud')

    const maskSize = {
      w: 0,
      h: 0,
    }

    const maskPosition = {
      y: 0,
    }

    const tick = (e) => {
      const { animatedScroll } = e // window.scrollYと似てる

      const bodyHeight = this.body.clientHeight

      const { innerWidth, innerHeight } = window

      // スクロール値が0~innerHeightまでの進捗をとる（0未満、1以上にならないように）
      const scene1 = Math.max(0, Math.min(1, animatedScroll / innerHeight))

      // 船が捌ける前のアニメーションをするための進捗をとる（0未満、1以上にならないように）

      const bunshi = animatedScroll + innerHeight - (bodyHeight - innerHeight * 0.5)
      const bunbo = innerHeight * 0.5

      const scene2 = Math.min(1, Math.max(0, bunshi / bunbo))
      const scene3 = Math.max(0, Math.min(1, (animatedScroll - innerHeight) / (innerHeight * 0.5)))

      maskSize.w = (easeInOutQuad(scene1) * 1 + 0) * Math.max(300, -innerWidth * 0.5 + 1200) + scene3 * 3000
      maskPosition.y = -innerHeight * (1 - scene1) + animatedScroll
      maskPosition.y -= innerHeight * 0.1 - innerHeight * 0.04 * scene1

      maskPosition.y = Math.min(maskPosition.y, bodyHeight - innerHeight)
      this.body.style.maskSize = `${maskSize.w}% ${100 + scene2 * 100}dvh`
      this.body.style.maskPosition = `center ${maskPosition.y}px`

      this.ship.style.top = `${scene1 * innerHeight - (innerHeight * 0.1 - innerHeight * 0.04 * scene1) + scene2 * innerHeight * 0.5}px`
      this.ship.style.width = `${-scene1 * 4 + 10}dvh`
      this.ship.style.opacity = 1 - scene2
      this.kv.style.setProperty('--opacity', 1 - scene3)
    }
    const opening = () => {
      setTimeout(() => {
        this.cloud.forEach((data) => {
          data.classList.add('is-act')
        })
      }, 300)
      setTimeout(() => {
        this.kvTitle.classList.add('is-act')
      }, 1000)
      setTimeout(() => {
        this.kvShip.classList.add('is-act')
      }, 1200)
    }
    opening()
    tick({ animatedScroll: 0 })
    smoothScroll.lenis.on('scroll', tick)
  }
}
